import {
  useQuery,
  UseQueryOptions,
  QueryFunction,
  QueryKey,
} from "@tanstack/react-query";
import {
  getStockMarkets,
  getStockScreenData,
  getStockSectors,
} from "../services/stockScreen.service";

export const useAllStockScreenDataHook = (queryParams: any) =>
  useQuery({
    queryKey: ["stock-screen", queryParams],
    queryFn: () => getStockScreenData(queryParams),
    // staleTime: 2 * 60 * 1000,
    // refetchInterval: 2 * 60 * 1000,
  });

export const useGetAllMarketHook = () =>
  useQuery({
    queryKey: ["stock-market"],
    queryFn: () => getStockMarkets(),
    // staleTime: 2 * 60 * 1000,
    // refetchInterval: 2 * 60 * 1000,
  });

export const useGetAllSectors = () =>
  useQuery({
    queryKey: ["stock-sectors"],
    queryFn: () => getStockSectors(),
    // staleTime: 2 * 60 * 1000,
    // refetchInterval: 2 * 60 * 1000,
  });
